import { useTheme as useThemeBse } from "@mui/styles";
export function useTheme() {
    return useThemeBse();
}
export function getUrl(domain, path = "/", ws = false) {
    const { host, https, port, token } = window.wdeSdk;
    if (ws) {
        return `${https ? "wss" : "ws"}://${host}:${port}/${domain}/${token}${path}`;
    }
    return `${https ? "https" : "http"}://${host}:${port}/${domain}/${token}${path}`;
}
//# sourceMappingURL=hooks.js.map